import { render } from "./BarcodeShow.vue?vue&type=template&id=2b43117c"
import script from "./BarcodeShow.vue?vue&type=script&lang=js"
export * from "./BarcodeShow.vue?vue&type=script&lang=js"
script.render = render

export default script